export class ListSelectionDialogViewModel
{
    id: string | null = null;

    title: string = "Pick from the list";
    description: string | null = null;
    items: { key: any, value: any, label: string, description: string }[] = [];
    selectedValue: string | null = null;
    valueRequired: boolean = false;
    isOpened: boolean = false;

    show(id: string, items: { key: any, value: any, label: string, description: string }[])
    {
        this.id = id;
        this.items = items;
        this.isOpened = true;
    }

    close()
    {
        this.isOpened = false;
    }
}